import React from "react";
// import PreQCFactoryComponent from "../../../components/FactoryModule/PostQCFact/garment.managepostqc.factory";
import PostQCFactoryComponent from "../../../components/FactoryModule/PostQC/postqclist.factory.component";

export default class PreQCFactoryScreen extends React.Component {
  render() {
    return <PostQCFactoryComponent />;
  }
}
